import { format } from "date-fns";
import appConstants from "../../appConstants";
import { isPickupStop } from "./IBPlanning/Common/MergeStops/utills";

const getSpecialNeeds = (priorityShipmentList, otherSpecialNeeds=[]) => {
  return [
    ...priorityShipmentList.map((priorityShipment) => ({
      value: priorityShipment,
      text: priorityShipment,
      icon: appConstants.PRIORITY_SHIPMENTS_ICONS[priorityShipment] || "icon-sgs5",
      tooltip: `${priorityShipment} shipment`,
    })),
    ...otherSpecialNeeds,
    ...appConstants.SpecialNeeds,    
  ];
};

const getPickupTypes = (priorityShipmentList) => {
  return [
    ...priorityShipmentList.map((priorityShipment) => ({
      value: priorityShipment,
      text: priorityShipment,
      icon:
        appConstants.PRIORITY_SHIPMENTS_ICONS[priorityShipment] || "icon-sgs5",
      tooltip: `${priorityShipment}`,
    })),
    ...appConstants.PICKUP_TYPES,
  ];
};

const getGridFeatureFlagsByGridNames = (gridConfiguration, gridName) => {
  return (
    gridConfiguration?.find((config) => config.gridName === gridName)?.value ??
    {}
  );
};

const getShipmentsDataByShipmentType = (shipments) => {
  return shipments.map((shipment) => {
    const { shipperLatitude, shipperLongitude, ...restShipmentData } = shipment;
    if (restShipmentData.isDelivery) {
      return restShipmentData;
    }
    return {
      ...restShipmentData,
      latitude: shipperLatitude,
      longitude: shipperLongitude,
    };
  });
};

const getStopsDataByType = (stops) => {
  return stops.map((stop) => {
    const { shipperLatitude, shipperLongitude, ...restShipmentData } = stop;
    if (isPickupStop(restShipmentData.stopType)) {
      return {
        ...restShipmentData,
        latitude: shipperLatitude,
        longitude: shipperLongitude,
      };
    }
    return restShipmentData;
  });
};

const getFormattedDeliveryDateTime = (deliveryDateTime) => {
  return deliveryDateTime
    ? format(deliveryDateTime, appConstants.DATETYPES.DATETIME.format)
    : "";
}

export {
  getSpecialNeeds,
  getPickupTypes,
  getGridFeatureFlagsByGridNames,
  getShipmentsDataByShipmentType,
  getStopsDataByType,
  getFormattedDeliveryDateTime
};
